import { useRef, useCallback, useEffect } from 'react';

const useGoogleRecaptchaV2 = ({ siteKey, widgetElRef, optionsRef, onSuccess, onExpired, onError, }) => {
    const widgetIdRef = useRef();
    const execute = useCallback(async () => {
        const { current: widgetId } = widgetIdRef;
        const { grecaptcha } = window;
        if (!grecaptcha || typeof widgetId !== 'number') {
            return undefined;
        }
        const result = await grecaptcha.execute(widgetId);
        return result;
    }, []);
    const reset = useCallback(() => {
        window.grecaptcha?.reset(widgetIdRef.current);
    }, []);
    useEffect(() => {
        const scriptId = 'google-recaptcha-script';
        if (document.getElementById(scriptId)) {
            return;
        }
        const scriptEl = document.createElement('script');
        scriptEl.id = scriptId;
        scriptEl.type = 'text/javascript';
        scriptEl.async = true;
        scriptEl.src = 'https://www.google.com/recaptcha/api.js';
        document.body.appendChild(scriptEl);
    }, []);
    useEffect(() => {
        const { current: widgetEl } = widgetElRef;
        if (!widgetEl) {
            return;
        }
        const onScriptReady = () => {
            if (typeof widgetIdRef.current === 'number') {
                return;
            }
            widgetIdRef.current = window.grecaptcha.render(widgetEl, {
                ...(optionsRef?.current ?? {}),
                sitekey: siteKey,
                ...(onSuccess ? { callback: onSuccess } : {}),
                ...(onExpired ? { 'expired-callback': onExpired } : {}),
                ...(onError ? { 'error-callback': onError } : {}),
            });
        };
        if (!window.grecaptcha) {
            const configKey = '___grecaptcha_cfg';
            window[configKey] = window[configKey] ?? { fns: [] };
            window[configKey].fns.push(onScriptReady);
        }
        else {
            grecaptcha.ready(onScriptReady);
        }
    }, [
        reset,
        siteKey,
        widgetElRef,
        optionsRef,
        onSuccess,
        onExpired,
        onError,
    ]);
    return {
        execute,
        reset,
    };
};

export { useGoogleRecaptchaV2 as u };
//# sourceMappingURL=hook-BsLXzwpe.js.map
